module.exports = __webpack_public_path__ + "img/dragon-worm-io.62da3313.jpg";